import * as React from "react";
const SvgArrowRight20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 14,
        fill: "black",
        viewBox: "0 0 9 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m.586 12 5-5-5-5L2 .586 8.414 7 2 13.414.586 12Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowRight20Px;
